import { useFetchSamlRedirectUrlMutation } from '../apis/loginApi';
import { useEffect } from 'react';
import { useNextQueryStringValue } from './useQueryString';
import isEmpty from 'lodash/isEmpty';

const useSsoRedirect = (username: string, isSsoRequired: boolean) => {
    const next = useNextQueryStringValue();

    const [fetchSamlRedirect, { data, isLoading, isError }] = useFetchSamlRedirectUrlMutation();

    useEffect(() => {
        if (data?.redirectUrl) {
            window.location.href = data?.redirectUrl;
        }
    }, [data?.redirectUrl]);

    useEffect(() => {
        if (isSsoRequired && !isEmpty(username)) {
            fetchSamlRedirect({ username, next });
        }
    }, [isSsoRequired, username]);

    return {
        isLoading,
        isError,
    };
};
export default useSsoRedirect;
